// src/app/shared/directives/translate.directive.ts
import { Directive, ElementRef, Input, OnInit, OnChanges } from '@angular/core';
import { TranslationService } from '../../services/translation.service';

@Directive({
  selector: '[appTranslate]'
})
export class TranslateDirective implements OnInit, OnChanges {
  @Input('appTranslate') key: string;

  constructor(
    private el: ElementRef,
    private translationService: TranslationService
  ) { }

  ngOnInit() {
    this.updateTranslation();
  }

  ngOnChanges() {
    this.updateTranslation();
  }

  private updateTranslation() {
    if (this.key) {
      this.el.nativeElement.innerHTML = this.translationService.translate(this.key);
    }
  }
}
